import { useNavigate, useLocation } from 'react-router-dom'
import { REPORTS_LIST_PATH } from '@config/reportRoutes'

/**
 * CC-49903: the report pages' in-app Back arrow returns to the page the user
 * actually came FROM — e.g. /reports?tab=<category>, preserving the selected
 * category — instead of hard-navigating to the fallback ("All reports").
 * The fallback covers cold loads (deep link / fresh tab), where there is no
 * in-app history entry to go back to (React Router keys those 'default').
 *
 * CC-49980: that fallback now names the reports LIST explicitly. A bare
 * '/reports' renders Dashboards once the Dashboards beta is on, so a cold-loaded
 * report (deep link, new tab, "open in new tab") sent Back straight out of the
 * reports area. Going back through real history is unchanged — if the user
 * genuinely started on Dashboards, navigate(-1) still returns them there.
 */
const useBackNav = (fallback = REPORTS_LIST_PATH) => {
  const navigate = useNavigate()
  const location = useLocation()
  return () => {
    if (location.key && location.key !== 'default') navigate(-1)
    else navigate(fallback)
  }
}

export default useBackNav
